import { generalTypes } from '../settings/types'

export const setViewMode = data => ({
    type: generalTypes.changeView,
    payload: data
})

export const clearState = () => ({
    type: generalTypes.clearState,
})

export const setFormInfo = (editMode=false, dataToEdit= null, viewMode='LIST') => ({
    type:generalTypes.infoToEdit,
    payload: { editMode, dataToEdit, viewMode }
})

export const setChildFormInfo = (editChildMode=false, childToEdit= null ) => ({
    type:generalTypes.childFormInfo,
    payload: { editChildMode, childToEdit }
})

export const changeLoadingState = data => ({
    type: generalTypes.loading,
    payload: data
})

export const setDataToEdit = data => ({
    type: generalTypes.dataToEdit,
    payload: data
})

export const setChildToEdit = data => ({
    type: generalTypes.childFormInfo,
    payload: data
})

export const setLangsInData = data => ({
    type: generalTypes.langsInData,
    payload: data
})

export const setLangChilds = data => ({
    type: generalTypes.langChilds,
    payload: data
})

export const setEnabledForm = data => ({
    type:generalTypes.enabledForm,
    payload: data
})

export const setEditMode = data => ({
    type:generalTypes.editMode,
    payload: data
})